import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function EditTaxAddressModalController () {
    this.busModal = mitt();
    this.address = null;

    this.alertModal = null;
    this.loadingModal = null;

    this.callbackOk = null;
    this.callbackCancel = null;
    this.callbackHidden = null;
    this.callbackEditSuccess = null;

    //#region setter
    this.clearModal = function() {
        this.callbackOk = null;
        this.callbackCancel = null;
        this.callbackHidden = null;
        this.callbackAddSuccess = null;
        return this;
    };
    this.setAlertModal = function(alertModal) {
        this.alertModal = alertModal;
    };
    this.setLoadingModal = function(loadingModal) {
        this.loadingModal = loadingModal;
    };
    this.setAddress = function (address) {
        this.address = address;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function () {
        let config = {
            address: this.address,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };

    this.onClickCancel = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackCancel = callback;
        }
    };
    this.sendCallbackCancel = function(data) {
        if (Util.isFunction(this.callbackCancel)) {
            this.callbackCancel(data);
        }
    };

    this.onHidden = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (Util.isFunction(this.callbackHidden)) {
            this.callbackHidden(data);
        }
    };

    this.onEditSuccess = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackEditSuccess = callback;
        }
    };
    this.sendCallbackEditSuccess = function(data) {
        if (Util.isFunction(this.callbackEditSuccess)) {
            this.callbackEditSuccess(data);
        }
    };
    //#endregion event
}
